export default __webpack_public_path__ + "static/media/appreciation.2563b3c2.jpg";